import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import {
    CartStep2InsuranceInterface,
    CartStep2InsuranceResponseInterface,
} from '../models/cart-step2-insurance.model';
import { CartStep2InsuranceRepository } from '../repositories/cart-step2-insurance.repository';

export class sendCartStep2InsuranceUseCase
    implements
        UseCase<
            CartStep2InsuranceInterface,
            CartStep2InsuranceResponseInterface
        >
{
    constructor(private readonly repository: CartStep2InsuranceRepository) {}

    execute(
        array: CartStep2InsuranceInterface,
    ): Observable<CartStep2InsuranceResponseInterface> {
        return this.repository.sendCartStep2Insurance(array);
    }
}
